// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"01245e74","732":"702c6792"}[chunkId] + ".chunk.js";
};